
class HelperTeaser {
    static getNbOccRenvoi(teaser) {
        var i = 0;
        if (teaser != null
            && teaser.textConditions != null) {
            if (teaser.textConditions.regularPaymentConditions != null) {
                i++;
            }
            if (teaser.textConditions.primaryTextConditions != null) {
                i++;
            }
            if (teaser.textConditions.ctaTeaserConditions != null) {
                i++;
            }
        }
        return i;
    }
}

export default HelperTeaser
